import React from 'react';
import HeroImage from '../../../assets/images/services/banking-license/hero-image.png'
import PageBanner from '../../../assets/images/services/banking-license/page-banner.png'

import BreadCrumbs from "../../../components/BreadCrumbs/BreadCrumbs";
import HeroRightImage from "../../../components/Constant/HeroRightImage/HeroRightImage";
import BannerPageImg from "../../../components/Constant/Banner Page Img/BannerPageImg";
import PageList from "../../../components/Constant/List/List";
import { GiCheckMark } from "react-icons/gi";
import { GoDotFill } from "react-icons/go";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import CTA from "../../../components/Constant/cta/CTA";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Button from "../../../components/Constant/button/Button";
import SEO from "../../../utils/SEO";

const BreadCrumbsData = [
    { name: 'Offshore Advisory', link: '/' },
    {
        name: 'Financial License – Anjouan (Comoros)',
        link: '/financial-license-anjouan',
    },
]

function FinancialLicenseAnjouan () {

    return (
        <main className='main'>
            <SEO
                title="Anjouan Financial License | AOFA Offshore Licensing"
                description="Get an Anjouan financial license for forex, brokerage, payments, and fintech. Fast approvals, low costs, and flexible offshore regulation. "
                keywords="Anjouan financial license, AOFA license, Comoros offshore license, forex license Anjouan, brokerage license offshore, EMI license Anjouan, fintech license Comoros, offshore financial services license"
                url="/financial-license-anjouan"
            />
            <section className='banking-license-section section'>
                <BreadCrumbs data={BreadCrumbsData}/>

                <div className='banking-license-container container'>

                    <h1 className='section-title'>
                        Financial License – Anjouan (Comoros)
                    </h1>

                    <div className='grid-container'>
                        <div className='flex-start'>
                            <h3 className='page-subtitle'>
                                Fast & Affordable Offshore Licensing for Financial Services
                            </h3>
                            <p className='page-paragraph'>
                                <b>Anjouan</b>, one of the islands of the <b>Union of Comoros</b>, has become a <b>leading offshore hub for financial services licensing</b>. Regulated by the <b>Anjouan Offshore Finance Authority (AOFA)</b>, it offers a <b>wide range of financial licenses</b> covering <b>forex, brokerage, payments, banking-lite, and fintech</b>. With <b>no capital requirements</b> and <b>fast approvals</b>, <b>Anjouan</b> is an attractive jurisdiction for both <b>startups and established firms</b>.
                            </p>

                            <PageList
                                items={[
                                    {
                                        title: "Forex & Brokerage",
                                        icon: GiCheckMark,
                                    },
                                    {
                                        title: "Payments & EMI",
                                        icon: GiCheckMark,
                                    },
                                    {
                                        title: "Banking Services",
                                        icon: GiCheckMark,
                                    },
                                    {
                                        title: "FinTech & PSP",
                                        icon: GiCheckMark,
                                    },
                                ]}
                            />
                            <Button
                                text="Request an Anjouan Financial License Proposal →"
                                link="/consultation"
                                type="primary"
                                size="large"
                            />
                        </div>

                        <HeroRightImage src={HeroImage} />
                    </div>

                    <BannerPageImg src={PageBanner} />
                    <b/><br/>

                    <div className='flex-start'>
                        <h3 className='page-title'>Why Choose Anjouan?</h3>
                        <PageList
                            items={[
                                {
                                    title: "No Capital Requirement",
                                    paragraph: "Unlike Mauritius, Seychelles, or Cyprus",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Fast Approvals",
                                    paragraph: "Licenses issued in 4–8 weeks",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Affordable Setup",
                                    paragraph: "Lower costs than most offshore jurisdictions",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Global Reach",
                                    paragraph: "Operate internationally under AOFA licensing",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Crypto & Fintech Friendly",
                                    paragraph: "Flexible framework for digital assets, PSPs, and fintech startups",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>What the License Covers</h3>
                        <p className='page-paragraph'>An Anjouan Financial License allows you to:</p>
                        <PageList
                            items={[
                                {
                                    paragraph: "Operate as a Forex & Brokerage Firm (STP, ECN, Market Maker, Prop Trading)",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "Provide Payment Services & EMI (Electronic Money Institution) functions",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "Offer Banking-Lite Services (remittances, IBAN issuing, card programs)",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "Run FinTech & PSP Operations (merchant processing, online payments)",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "Combine Forex + Crypto Brokerage or Forex + Payments under one structure",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Benefits of an Anjouan Financial License</h3>
                        <PageList
                            items={[
                                {
                                    title: "Global Acceptance",
                                    paragraph: "Recognized by PSPs, EMIs, and fintech partners",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Startup-Friendly",
                                    paragraph: "Fast setup and no heavy compliance burden",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Banking & Payment Access",
                                    paragraph: "Easier to open EMI/PSP accounts than with unlicensed entities",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Scalable",
                                    paragraph: "Expand from forex to payments, or payments to crypto",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Affordable",
                                    paragraph: "Much lower entry cost than EU or Tier-1 regulators",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Licensing Process</h3>
                        <PageList
                            items={[
                                {
                                    title: "Consultation & Structuring",
                                    paragraph: "Select business model (brokerage, PSP, EMI, hybrid)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Company Incorporation",
                                    paragraph: "Establish an IBC in Anjouan",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Compliance Preparation",
                                    paragraph: "AML/KYC manuals, risk management, business plan",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Application Filing",
                                    paragraph: "Offshore Advisory submits to AOFA",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Approval & License Issuance",
                                    paragraph: "Typically within 4–8 weeks",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Timeline & Costs</h3>
                        <PageList
                            items={[
                                {
                                    title: "Timeline",
                                    paragraph: "4–8 weeks (among the fastest globally)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Setup Costs",
                                    paragraph: "From USD 19,000–20,000+ depending on services",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Capital Requirement",
                                    paragraph: "None",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Annual Renewal Fees",
                                    paragraph: "Low compared to Seychelles or Mauritius",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Why Offshore Advisory?</h3>
                        <PageList
                            items={[
                                {
                                    title: "Authorized AOFA Agent",
                                    paragraph: "Experience in all financial license types",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "End-to-End Solution",
                                    paragraph: "Incorporation, compliance, license filing, banking introductions",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Access to MT4/MT5 White Labels",
                                    paragraph: "Liquidity providers and payment processors",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Assistance with Crypto PSP and EMI Accounts",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Transparent Pricing & Reliable Support",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                            ]}
                        />
                    </div>

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>
                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />
                    <CTA
                        title="Looking to operate a forex, brokerage, or fintech business?"
                        description=
                            "<b>Anjouan</b> offers one of the <b>fastest</b> and <b>most affordable offshore financial licenses</b> in the world."
                        buttonText="Request Your Banking License Proposal →"
                        buttonLink="/consultation"
                    />

                </div>
            </section>


        </main>
    );
}

export default FinancialLicenseAnjouan;

const faqData = [
    {
        question: "Is there a capital requirement for an Anjouan financial license?",
        content: [
            { type: "answer", text: "No — unlike Mauritius or Cyprus, AOFA does not require minimum capital." },
        ],
    },
    {
        question: "How long does it take to get licensed?",
        content: [
            { type: "answer", text: "Typically 4–8 weeks, faster than most offshore centers." },
        ],
    },
    {
        question: "Can I operate globally with this license?",
        content: [
            { type: "answer", text: "Yes — Anjouan licenses are designed for international operations, not domestic business." },
        ],
    },
    {
        question: "Can I combine services (e.g., forex + payments)?",
        content: [
            { type: "answer", text: "Yes — AOFA offers modular licensing so you can combine multiple services." },
        ],
    },
    {
        question: "Is it crypto-friendly?",
        content: [
            { type: "answer", text: "Yes — crypto payments, exchanges, and hybrid forex + crypto models are supported." },
        ],
    },
];

const testimonialsData = [
    {
        quote:
            "We obtained a financial license in Anjouan within 6 weeks. Offshore Advisory handled the entire process seamlessly.",
        author: "Mark T.",
        role: "FinTech Founder",
    },
    {
        quote:
            "Offshore Advisory helped us license a forex & payments hybrid under AOFA. Fast, affordable, and effective.",
        author: "Elena S.",
        role: "Brokerage CEO",
    },
];